(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["motw-health-header"]) return;
  try {
    
document.addEventListener('click',event=>{const link=event.target.closest('.mhe-menu a');if(link)link.closest('details').open=false;});document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.mhe-menu[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus();});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["motw-health-library"] && !Shopify.designMode) return;
  try {
    
function initMheLibrary(root){if(root.dataset.ready)return;root.dataset.ready='true';const panels=[...root.querySelectorAll('.mhe-topic-panel')];const topicLinks=[...root.querySelectorAll('[data-topic]')];function select(key,moveFocus){const panel=panels.find(p=>p.dataset.key===key);if(!panel)return;panels.forEach(p=>p.hidden=p!==panel);topicLinks.forEach(a=>a.setAttribute('aria-current',String(a.dataset.topic===key)));if(moveFocus){root.querySelector('#mhe-library').scrollIntoView({block:'start'});panel.querySelector('h3').focus({preventScroll:true});}}if(panels.length)select(panels[0].dataset.key,false);root.querySelectorAll('[data-topic],[data-open-topic]').forEach(a=>a.addEventListener('click',e=>{e.preventDefault();select(a.dataset.topic||a.dataset.openTopic,a.hasAttribute('data-open-topic'));}));const input=root.querySelector('input[type=search]'),results=root.querySelector('.mhe-search-results'),status=root.querySelector('.mhe-search-status'),links=root.querySelector('.mhe-result-links');function search(){const query=input.value.trim().toLowerCase();links.replaceChildren();if(!query){results.hidden=true;return;}const words=query.split(/\s+/);const matches=panels.filter(p=>words.every(w=>p.dataset.search.toLowerCase().includes(w)));results.hidden=false;status.textContent=matches.length?root.dataset.resultsLabel+' '+matches.length:root.dataset.noResults;matches.forEach(p=>{const b=document.createElement('button');b.type='button';b.textContent=p.dataset.label+' →';b.addEventListener('click',()=>select(p.dataset.key,true));links.append(b);});}input.addEventListener('input',search);root.querySelector('form').addEventListener('submit',e=>{e.preventDefault();search();});root.addEventListener('shopify:block:select',e=>select(e.detail.blockId,false));}
document.querySelectorAll('[data-mhe-library]').forEach(initMheLibrary);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-mhe-library]').forEach(initMheLibrary));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["motw-health-shop"] && !Shopify.designMode) return;
  try {
    
function initMheShop(root){
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  const cards=[...root.querySelectorAll('[data-mhe-product]')];
  const more=root.querySelector('.mhe-more-products');
  if(cards.length>3&&root.dataset.showAll!=='true'){
    more.hidden=false;
    cards.slice(3).forEach(card=>card.hidden=true);
    more.addEventListener('click',()=>{
      const open=more.getAttribute('aria-expanded')!=='true';
      more.setAttribute('aria-expanded',String(open));
      cards.slice(3).forEach(card=>card.hidden=!open);
      more.textContent=open?more.dataset.less:more.dataset.more;
    });
  }
  root.querySelectorAll('.mhe-swatch').forEach(button=>button.addEventListener('click',()=>{
    const card=button.closest('[data-mhe-product]');
    const img=card.querySelector('img');
    card.querySelectorAll('.mhe-swatch').forEach(swatch=>swatch.setAttribute('aria-pressed',String(swatch===button)));
    if(img){img.removeAttribute('srcset');img.src=button.dataset.src;img.alt=card.querySelector('h3').textContent+' — '+button.dataset.colour;}
    card.querySelector('.mhe-colour-name').textContent=button.dataset.colour;
    if(button.dataset.url)card.querySelectorAll('[data-product-link]').forEach(link=>link.href=button.dataset.url);
    const price=card.querySelector('[data-product-price]');
    if(button.dataset.price&&price)price.textContent=button.dataset.price;
  }));
  root.addEventListener('shopify:block:select',()=>{
    cards.forEach(card=>card.hidden=false);
    if(more){more.setAttribute('aria-expanded','true');more.textContent=more.dataset.less;}
  });
}
document.querySelectorAll('[data-mhe-shop]').forEach(initMheShop);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-mhe-shop]').forEach(initMheShop));

  } catch(e) { console.error(e); }
})();
})();
